export const data = [
  {
    id: 1,
    title: "Approfondir TypeScript",
    description: "Faire tous les exercices",
    done: false
  },
  {
    id: 2,
    title: "Finir l'app React",
    description: "Faire tous les composants",
    done: false
  },
  {
    id: 3,
    title: "Faire de l'algo",
    description: "M'entraîner à la gestion des arrays",
    done: false
  },
  {
    id: 4,
    title: "Me reposer",
    description: "Faire une grasse matinée samedi matin",
    done: false
  }
];
